// src/App.js

import React, { useEffect } from 'react'
import { HashRouter as Router, Routes, Route , Navigate} from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import PrivateRoute from './routes/PrivateRoute'
import './i18n' 
import { useTranslation } from 'react-i18next'
import Navbar from './components/Navbar'

// Sayfalar

import Profile from './pages/Profile'
import Login from './pages/Login'
import Register from './pages/Register'
import ForgotPassword from './pages/ForgotPassword'

// Yeni Sayfalar

import ProjectsPage from './pages/ProjectsPage'
import CategoryPage from './pages/CategoryPage'
import EntityPage from './pages/EntityPage'
import DashboardPage from './pages/DashboardPage'
import NewProjectPage from './pages/NewProjectPage'
import AdminUsersPage from './pages/AdminUsersPage' 
import CodebookLibraryPage from './pages/CodebookLibraryPage'
import ReportDashboard from './pages/ReportDashboard'
import SegmentationPage from './pages/SegmentationPage'
import AddDataToProject from './pages/AddDatatoProject'



function App() {
  const { i18n } = useTranslation()

  // Dil değiştiğinde document lang özelliğini güncelleyin
  useEffect(() => {
    document.documentElement.lang = i18n.language
  }, [i18n.language])

  return (
    <Router>
      <AuthProvider>
        <Navbar />
        <Routes>
          {/* Public routes: kimliklendirme sayfaları */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />

          <Route path="/" element={<Navigate to="/login" replace />} />
  
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />

          <Route
            path="/ProjectsPage"
            element={
              <PrivateRoute >
                <ProjectsPage />
              </PrivateRoute>
            }
          />
          
          <Route
            path="/category"
            element={
              <PrivateRoute >
                <CategoryPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/entity"
            element={
              <PrivateRoute >
                <EntityPage />
              </PrivateRoute>
            }
          />  

          <Route
            path="/dashboard"
            element={
              <PrivateRoute >
                <DashboardPage />
              </PrivateRoute>
            }
          />  

          <Route
            path="/new-project"
            element={
              <PrivateRoute >
                <NewProjectPage />
              </PrivateRoute>
            }
          />  

          <Route
            path="/LibraryPage"
            element={
              <PrivateRoute >
                <CodebookLibraryPage />
              </PrivateRoute>
            }
          /> 

          <Route
            path="/ReportDashboard"
            element={
              <PrivateRoute >
                <ReportDashboard />
              </PrivateRoute>
            }
          />  

          <Route
            path="/SegmentationPage"
            element={
              <PrivateRoute >
                <SegmentationPage />
              </PrivateRoute>
            }
          />  

          <Route
            path="/addData"
            element={
              <PrivateRoute >
                <AddDataToProject />
              </PrivateRoute>
            }
          />  


          {/* Yeni: Kullanıcı Yönetimi rotası */}
          <Route
            path="/admin-users"
            element={
              <PrivateRoute adminOnly>
                <AdminUsersPage />
              </PrivateRoute>
            }
          />

        </Routes>
      </AuthProvider>
    </Router>
  )
}

export default App